<template>
  <generic-modal
    size
    :title="$t('human tasks')"
    icon="check list"
    image="/images/icons/human_task.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h4 class="ui dividing header">{{ $t("general info") }}</h4>
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div>
        <div class="field">
          <label for>{{ $t("description") }}</label>
          <textarea
            name="description"
            rows="2"
            v-model="description"
          ></textarea>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { v4 as uuid } from "uuid";
// import Swatches from "vue-swatches";

export default {
  components: {
    "generic-modal": GenericModal
    // Swatches
  },
  computed: {},
  props: { human_task: Object, project: Object },
  data() {
    return {
      description: "",
      name: ""
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let ht = {
            uuid: vm.$props.human_task.uuid || uuid(),
            name: vm.name,
            description: vm.description
          };
          vm.$emit("succedded", ht);
          resolve();
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"]
      }
    });

    if (
      vm.$props.project &&
      vm.$props.project.setup &&
      vm.$props.project.setup.business_objects
    ) {
      let vls = vm.$props.project.setup.business_objects.map((d) => {
        return { value: d.uuid, name: d.name };
      });
      vm.arg_types = vls;
    }

    let ht = vm.$props.human_task;
    if (ht.uuid) {
      vm.name = ht.name;
      vm.description = ht.description;
    }
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {
      window.jQuery(this.$refs.type_dropdown).dropdown();
    });
  }
};
</script>
